
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'TButtonGroup',
})
export default class TButtonGroup extends Vue {}
